import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    creatingInvitation: -1,
  },
  id: '',
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.INVITATION_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          creatingInvitation: 0,
        },
      };
    case ACTION_TYPES.INVITATION_CREATE_SUCCEED: {
      const id = payload.result.data;
      return {
        ...state,
        id,
        status: {
          ...state.status,
          creatingInvitation: 1,
        },
      };
    }
    case ACTION_TYPES.INVITATION_CREATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          creatingInvitation: 2,
        },
        error,
      };
    case ACTION_TYPES.INVITATION_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
